'use client';

import type { HTMLChakraProps, RecipeProps } from '@chakra-ui/react';
import { createRecipeContext } from '@chakra-ui/react';

export interface ButtonAsLinkProps extends HTMLChakraProps<'button', Omit<RecipeProps<'link'>, 'href'>> {}

const { withContext } = createRecipeContext({ key: 'link' });

// Replace "a" with your framework's link component
export const ButtonAsLink = withContext<HTMLButtonElement, ButtonAsLinkProps>('button');
